import React, { useEffect, useState } from "react";
import { getBusinessDaysAgo, momentFecha } from "../../../utils/funciones";
/// import { useUnidadRolTemporis } from "../../../hooks/datosLaborales";
import { InputSelect } from "../../formComponents/inputSelect";
import { InputFecha } from "../../formComponents/inputFecha";
import { useDatosLaborales } from "./useDatosLaborales";
import { PLAZOS } from "../../../utils/Constants";
import ErrorInput from "../../ui/ErrorInput";
import { post } from "../../../api/apis";
import PropTypes from "prop-types";
import moment from "moment";

const FormDatosLaborales = ({ bloqueado, formik, verVacante }) => {
  const [arrPlanHorario, setArrPlanHorario] = useState([]);
  const [dataTemporis, setDataTemporis] = useState([]);
  //e const { setRolTemporis } = useUnidadRolTemporis();
  const fechaMaximaIngreso = moment().add(6, 'months').format('YYYY-MM-DD');
  const fechaLaboralMinima = getBusinessDaysAgo(5);
  const { arrDivisionPersonal, getDivisionPersonal, posicionesLaborales, getPosicionesLaborales, getPlanHorarioInCargo } = useDatosLaborales();

  useEffect(() => {
    getDivisionPersonal();
  }, []);

  useEffect(() => {
    getPosicionesLaborales(formik.values.datosLaborales.divisionPersonal);
    if (!formik.values.datosLaborales.divisionPersonal) {
      formik.setValues({ ...formik.values, datosLaborales: { ...formik.values.datosLaborales, cargo: '' } });
    }
  }, [formik.values.datosLaborales.divisionPersonal]);

  useEffect(() => {
    if (formik.values.datosPersonales.rut !== '') {
      localStorage.setItem('rut', formik.values.datosPersonales.rut)
    }
  }, [formik.values.datosPersonales.rut])

  async function traerTemporis(codDivision) {
    /// setRolTemporis(formik);
    formik.values.datosLaborales.planHorario = "";
    formik.setValues(formik.values);

    if (formik.values.datosLaborales.cargo) {
      const cargo = JSON.parse(formik.values.datosLaborales.cargo)?.MOES_DESCRIPCION_POSICION;
      const horario = getPlanHorarioInCargo(cargo);
      const temporis = await post('temporis', null, { plan_horario: horario, cod_division: codDivision });

      formik.values.datosLaborales.tieneTemporis = Boolean(temporis.data.data);

      setArrPlanHorario(temporis.data.data);
      setDataTemporis(temporis.data.unidad_organizativa_rol_temporis);
    }
  }

  useEffect(() => {
    setArrPlanHorario([]);
    traerTemporis(formik.values.datosLaborales.divisionPersonal);
  }, [formik.values.datosLaborales.cargo]);


  const calcularFechaFinContrato = (ingreso, contrato) => {
    const formatoFecha = "YYYY-MM-DD";
    const diaDeIngreso = moment(ingreso).get("date");

    switch (contrato) {
      case "1":
        if (diaDeIngreso === 1) {
          const fecha = moment(ingreso)
            .add(1, "months")
            .subtract(1, "days")
            .format(formatoFecha);
          return fecha;
        }
        if (diaDeIngreso > 1) {
          const fecha = moment(ingreso)
            .add(1, "months")
            .endOf("month")
            .format(formatoFecha);
          return fecha;
        }

        break;
      case "2":
        if (diaDeIngreso === 1) {
          const fecha = moment(ingreso)
            .add(2, "months")
            .subtract(1, "days")
            .format(formatoFecha);
          return fecha;
        }
        if (diaDeIngreso > 1) {
          const fecha = moment(ingreso)
            .add(2, "months")
            .endOf("month")
            .format(formatoFecha);
          return fecha;
        }
        break;
      case "3":
        if (diaDeIngreso === 1) {
          const fecha = moment(ingreso)
            .add(3, "months")
            .subtract(1, "days")
            .format(formatoFecha);
          return fecha;
        }
        if (diaDeIngreso > 1) {
          const fecha = moment(ingreso)
            .add(3, "months")
            .endOf("month")
            .format(formatoFecha);
          return fecha;
        }
        break;
      case "4":
        return "9999-12-31";

      default:
        return null;

    }
  }

  useEffect(() => {
    if (formik.values.datosLaborales.fechaFinContrato && !formik.values.datosLaborales.fechaIngreso) {
      formik.values.datosLaborales.fechaFinContrato = "";
    }

    if (formik.values.datosLaborales.fechaIngreso && formik.values.datosLaborales.tipoContrato) {
      formik.values.datosLaborales.fechaFinContrato = calcularFechaFinContrato(
        formik.values.datosLaborales.fechaIngreso,
        formik.values.datosLaborales.tipoContrato
      );
    }
  }, [formik.values.datosLaborales.fechaIngreso, formik.values.datosLaborales.tipoContrato]);

  useEffect(() => {
    formik.setValues({ ...formik.values, datosLaborales: { ...formik.values.datosLaborales, unidadOrganizativaRolTemporis: '' } });
  }, [formik.values.datosLaborales.planHorario]);

  return (
    <>
      <div className="row mt-3">
        <div className="col-12 col-sm-6 my-1">
          <InputFecha
            label='Fecha de ingreso *'
            minima={fechaLaboralMinima.format('YYYY-MM-DD')}
            maxima={fechaMaximaIngreso}
            formik={formik}
            subObjeto={['datosLaborales', 'fechaIngreso']}
          />
        </div>
        <div className="col-12 col-sm-6 my-1">
          <InputSelect
            label='División de personal *'
            subObjeto={['datosLaborales', 'divisionPersonal']}
            arrData={arrDivisionPersonal}
            formik={formik}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-sm-6 my-1">
          <InputSelect
            label='Tipo de contrato *'
            subObjeto={['datosLaborales', 'tipoContrato']}
            arrData={PLAZOS}
            formik={formik}
          />
        </div>
        <div className="col-12 col-sm-6 my-1">
          <label htmlFor="cargo">Cargo *</label>
          <select
            id="inputCargo"
            className="form-select"
            name="datosLaborales.cargo"
            aria-label="Default select example"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.datosLaborales.cargo}
          >
            <option value="">Seleccione</option>
            {
              posicionesLaborales &&
              Object.keys(posicionesLaborales).map((el, indx) => {
                return (
                  <>
                    <option className="bg-dark text-white" value='' key={Number.parseInt(indx)}>{el}</option>
                    {
                      posicionesLaborales[el].map((ell, indxx) => {
                        return <option value={JSON.stringify(ell)} key={`${Number.parseInt(indxx)}-tt'`}>{ell.MOES_COD_POSICION} {ell.MOES_DESCRIPCION_POSICION}</option>
                      })
                    }
                  </>
                )
              })
            }
          </select>
          {formik.errors.datosLaborales !== undefined &&
            formik.touched.datosLaborales !== undefined && (
              <ErrorInput
                touched={formik.touched.datosLaborales.cargo}
                error={formik.errors.datosLaborales.cargo}
              />
            )}
        </div>

      </div>
      <div className="row">
        {
          formik.values.datosLaborales.cargo && (
            <div className="col-12 col-sm-6 my-1">
              <label htmlFor="planHorario">Plan horario *</label>
              <select
                /// disabled={bloqueado}
                className="form-select"
                name="datosLaborales.planHorario"
                aria-label="Default select example"
                onChange={
                  (e) => {
                    const texto = e.target.options[e.target.selectedIndex].text;
                    /// setRolTemporis(formik);
                    formik.values.datosLaborales.planHorario = texto === "Seleccione" ? "" : texto;
                    formik.setValues(formik.values);
                  }
                }
                onBlur={formik.handleBlur}
                value={formik.values.datosLaborales.planHorario}
              >
                <option value="">Seleccione</option>
                {
                  (arrPlanHorario.length > 0) &&
                  arrPlanHorario.map((horario, indx) => (
                    <option value={horario.Planhorarionombre} key={`${Number.parseInt(indx)}-j`}>
                      {horario.Planhorarionombre}
                    </option>
                  ))
                }
              </select>
              {formik.errors.datosLaborales !== undefined &&
                formik.touched.datosLaborales !== undefined && (
                  <ErrorInput
                    touched={formik.touched.datosLaborales.planHorario}
                    error={formik.errors.datosLaborales.planHorario}
                  />
                )}
            </div>
          )

        }

        {
          (formik.values.datosLaborales.planHorario &&
            formik.values.datosLaborales.cargo &&
            dataTemporis.length > 0 &&
            formik.values.datosLaborales.planHorario !== "PHTD - Artículo 22"
          ) && (
            <div className="col-12 col-sm-6 my-1">
              <label htmlFor="unidadOrganizativaRolTemporis">Unidad organizativa - Rol Temporis *</label>
              <select
                className="form-select"
                name="datosLaborales.unidadOrganizativaRolTemporis"
                aria-label="Default select example"
                onChange={
                  (e) => {
                    formik.values.datosLaborales.unidadOrganizativaRolTemporis = e.target.value;
                    formik.setValues(formik.values);
                  }
                }
                onBlur={formik.handleBlur}
                value={formik.values.datosLaborales.unidadOrganizativaRolTemporis}
              >
                <option value="">Seleccione</option>
                {
                  dataTemporis.length !== 0 &&
                  dataTemporis.map((horario, indx) => (
                    <option value={JSON.stringify(horario)} key={Number.parseInt(indx)}>{horario.Unidadorganizativa} - {horario.Cargogenericonombre}</option>
                  ))
                }
              </select>
              {formik.errors.datosLaborales !== undefined &&
                formik.touched.datosLaborales !== undefined && (
                  <ErrorInput
                    touched={formik.touched.datosLaborales.unidadOrganizativaRolTemporis}
                    error={formik.errors.datosLaborales.unidadOrganizativaRolTemporis}
                  />
                )}
            </div>
          )
        }
      </div>

      <div className="row">
        {formik.values.datosLaborales.fechaIngreso && formik.values.datosLaborales.tipoContrato && formik.values.datosLaborales.tipoContrato !== "4" && (
          <div className="col-12 col-sm-6 my-1">
            <label htmlFor="fechaRetiro">Fecha Fin Contrato</label>
            <input
              type="text"
              name="datosLaborales.fechaRetiro"
              className="form-control"
              readOnly
              value={momentFecha(formik.values.datosLaborales.fechaFinContrato)}
            />
          </div>
        )}
      </div>
    </>
  );
};

FormDatosLaborales.propTypes = {
  bloqueado: PropTypes.bool,
  formik: PropTypes.object.isRequired,
  verVacante: PropTypes.bool,
};

export default FormDatosLaborales;
